import './Loader.css';

function Loader() {

    return (
        <span className="loader_parent">
            <span className="loader">
                <span></span>
            </span>
        </span>
    )
}

export default Loader;